// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/data1/jenkins/workspace/aplus_tiger_my_level_20230614092632_tiger-platform_udb_my_level_115719_nodejs_prod/node_modules/.pnpm/@umijs+runtime@3.5.41_react@16.14.0/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/Loading';

export function getRoutes() {
  const routes = [
  {
    "path": "/index.html",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index' */'@/pages/index'), loading: LoadingComponent}),
    "title": "我的等级",
    "exact": true
  },
  {
    "path": "/gradeRule.html",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gradeRule' */'@/pages/gradeRule'), loading: LoadingComponent}),
    "title": "我的等级说明",
    "exact": true
  },
  {
    "path": "/expDetail.html",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__expDetail' */'@/pages/expDetail'), loading: LoadingComponent}),
    "title": "经验值明细",
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
